var render = function render(){var _vm=this,_c=_vm._self._c;return _c('K2Row',{staticClass:"filterList customScroll"},_vm._l((_vm.postNavList),function(nav){return _c('K2Text',{attrs:{"class-name":"me-3","link":"true","color":nav.color},on:{"onclick":() => _vm.handleChangePost(nav)}},[_vm._v("\n    "+_vm._s(nav.label)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }